import { Box, Chip, Paper, Table, TableBody, TableCell, TableRow, Typography, Stack, Button, Link } from '@mui/material'
import React, { ReactElement, ReactNode } from 'react'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import FileInput from 'components/common/FileInput/FileInput'
import { downloadDocument } from 'utils/downloadDocument'
import useNotification from 'hooks/useNotification'

type DataListProps = {
  title?: ReactNode
  description?: ReactNode
  data: any
  button?: ReactNode
  icon?: ReactElement
  status?: {
    color?: 'error' | 'success'
    text: string
  }
  downloadLink?: string
  downloadFileName?: string
  id?: string
}

const DataBox: React.FC<DataListProps> = ({
  title,
  description,
  data,
  icon,
  button,
  status,
  downloadLink,
  downloadFileName,
  id,
}) => {
  const notify = useNotification()

  // Without the catch, a rejected download surfaces as an uncaught runtime
  // error overlay rather than something the person can read and act on.
  const handleDownload = async () => {
    try {
      await downloadDocument(downloadLink, downloadFileName)
    } catch (error) {
      notify('error', error instanceof Error ? error.message : 'Het document kon niet worden gedownload.')
    }
  }

  return (
    <Paper variant="outlined" component={Stack} spacing="20px" id={id}>
      <Box>
        <Stack direction="row">
          {icon && <Box sx={{ marginRight: '20px' }}>{icon}</Box>}
          {title && (
            <Typography fontWeight="bold" sx={{ flexGrow: 0 }}>
              {downloadLink ? (
                <Link
                  component="button"
                  type="button"
                  underline="always"
                  sx={{ color: 'black', font: 'inherit', textAlign: 'left', cursor: 'pointer' }}
                  onClick={handleDownload}
                >
                  {title}
                </Link>
              ) : (
                title
              )}
            </Typography>
          )}
        </Stack>

        {description && description}
      </Box>
      <Table sx={{ marginTop: '0!important' }}>
        <TableBody>
          {data.map((row: any) => {
            return (
              <TableRow key={row.key}>
                <TableCell sx={{ padding: '8px 0!important', minWidth: '50%' }}>{row.key}</TableCell>
                <TableCell sx={{ padding: '8px 0!important', maxWidth: '50%', width: '50%' }}>{row.value}</TableCell>
              </TableRow>
            )
          })}
          {status && (
            <TableRow>
              <TableCell sx={{ padding: '8px 0!important' }}>Status</TableCell>
              <TableCell sx={{ padding: '8px 0!important' }}>
                <Chip label={status.text} color={status.color} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {button && button}
    </Paper>
  )
}

export default DataBox
